import { render, staticRenderFns } from "./DefaultApp.vue?vue&type=template&id=5947bc9c"
import script from "./DefaultApp.vue?vue&type=script&lang=js"
export * from "./DefaultApp.vue?vue&type=script&lang=js"
import style0 from "./DefaultApp.vue?vue&type=style&index=0&id=5947bc9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports